import { OrganizationDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/core/v1/organization_events_pb';
import { Col } from '@rematter/ui-web';
import { FieldDisplay, IDField } from '@rematter/ui-web';

type OrganizationDeletedDetailProps = {
  event: OrganizationDeletedEvent;
};

export const OrganizationDeletedDetail = ({
  event,
}: OrganizationDeletedDetailProps) => {
  const organization = event.organization;

  if (!organization) {
    return (
      <Col className="@OrganizationDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  return (
    <Col className="@OrganizationDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Organization
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={organization.id?.value} />
          <FieldDisplay label="Name" value={organization.name} />
          <FieldDisplay label="Domain" value={organization.domain} />
          <FieldDisplay label="Timezone" value={organization.timezone?.name} />
        </div>
      </Col>
    </Col>
  );
};
